module.exports = __webpack_public_path__ + "static/media/dy.4ee52b1c.svg";